import GetProfileConfigInfo from "../entities/getProfileConfigInfo";
import { OnboardingRepository } from "../repositories/OnboardingRepository";

export class GetProfileConfig {
	constructor(private repository: OnboardingRepository) {}
	execute(): Promise<GetProfileConfigInfo> {
		return this.repository.getProfileConfig();
	}
}
